import { useLayoutEffect } from 'react';

export const useClientOnlyLayoutEffect = __SERVER__ ? () => {} : useLayoutEffect;
